import { supportedTimezones } from 'config/Vars'
import moment from 'moment-timezone'

export function timezoneToString(tzValue: string | undefined): string {
  return tzValue ? `${tzValue} (UTC${moment.tz(tzValue).format('Z')})` : ''
}

export function timezoneOptions() {
  return supportedTimezones.map((timezone) => ({
    label: timezoneToString(timezone),
    value: timezone,
  }))
}
